const colorMap: Record<string, string> = {
  HIGH: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  MEDIUM: "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200",
  LOW: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};

export const ConfidenceBadge = ({ value }: { value?: string }) => {
  if (!value) return <span>—</span>;
  const upper = value.toUpperCase();
  const colors = colorMap[upper] || "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${colors}`}>
      {upper}
    </span>
  );
};
